import React from "react"
import createReactClass from "create-react-class"
import ClassNames from "classnames"
import Styles from "./../validation.less"
import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"

var ValidationBox = createReactClass({
  getClass() {
    return ClassNames(Styles.box, this.props.className)
  },
  render() {
    let props = {
      onClick: this.props.onClick,
      onFocus: this.props.onFocus,
      onBlur: this.props.onBlur,
      onMouseEnter: this.props.onMouseEnter,
      onMouseLeave: this.props.onMouseLeave,
      onMouseDown: this.props.onMouseDown,
      onMouseUp: this.props.onMouseUp,
      className: this.getClass(),
      disabled: this.props.disabled,
      tabIndex: this.props.tabIndex,
      autoFocus: this.props.autoFocus,
    }

    return <div {...props}> {this.props.children} </div>
  },
})

export default ValidationMixin(ValidationBox)
